module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('onboarding-wizard', {
    attrs: {
      "userStatus": _vm.userStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(!_vm.uploadSucceeded && _vm.needsDocumentation && _vm.documentationReason) ? _c('div', [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDocumentationReason()))])])]) : _vm._e(), _vm._v(" "), (_vm.uploadFailed) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("Make sure that your documentation is in a valid format and is no more than 10 MB.")])]) : _vm._e(), _vm._v(" "), (_vm.uploadSucceeded) ? _c('div', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.documentationInReview) ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "mt-lg"
  }, [_vm._v("In order to complete verifying your personal information, we need you to upload a copy of one of the following documents:")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "type": "radio",
      "name": "documentType",
      "value": "license"
    },
    domProps: {
      "checked": _vm._q(_vm.documentType, "license")
    },
    on: {
      "__c": function($event) {
        _vm.documentType = "license"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  }), _vm._v("Driver's license")])]), _vm._v(" "), _c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "type": "radio",
      "name": "documentType",
      "value": "passport"
    },
    domProps: {
      "checked": _vm._q(_vm.documentType, "passport")
    },
    on: {
      "__c": function($event) {
        _vm.documentType = "passport"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  }), _vm._v("Passport")])]), _vm._v(" "), _c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "type": "radio",
      "name": "documentType",
      "value": "idCard"
    },
    domProps: {
      "checked": _vm._q(_vm.documentType, "idCard")
    },
    on: {
      "__c": function($event) {
        _vm.documentType = "idCard"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  }), _vm._v("ID card")])]), _vm._v(" "), _c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "type": "radio",
      "name": "documentType",
      "value": "other"
    },
    domProps: {
      "checked": _vm._q(_vm.documentType, "other")
    },
    on: {
      "__c": function($event) {
        _vm.documentType = "other"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  }), _vm._v("Other")])])]), _vm._v(" "), (_vm.selectedFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel discoverer",
    attrs: {
      "data-filter-group": "image"
    }
  }, [_c('div', {
    staticClass: "panel-body text-center"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-dark"
  }, [_vm._v(_vm._s(_vm.selectedFile.name))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix m0 text-muted"
  }, [_c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s((_vm.selectedFile.size / 1024).toFixed(2).toString() + "KB"))])])])])])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group mt-lg",
    class: {
      'has-error': _vm.isFileInvalid
    }
  }, [_c('input', {
    staticClass: "form-control filestyle",
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0px 0px 0px 0px)"
    },
    attrs: {
      "type": "file",
      "data-classbutton": "btn btn-default",
      "data-classinput": "form-control inline",
      "id": "filestyle-0",
      "tabindex": "-1",
      "accept": _vm.getAcceptedFileExtensions()
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bootstrap-filestyle input-group"
  }, [_c('input', {
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedFile ? _vm.selectedFile.name : ''
    }
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), (_vm.isFileInvalid) ? _c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("The file you selected is not valid. Please select a different file.")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Your file must be in " + _vm._s(_vm.supportedFileExtensions) + " format and cannot exceed 10MB.")])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit()
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_vm._v("Submit")])])])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n       Upload Documentation\n       "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "fa fa-warning pr-sm"
  }), _vm._v("Verification of your documents failed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "fa fa-warning pr-sm"
  }), _vm._v("There was a problem uploading your documentation. Please try again.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("We've received your documentation")]), _vm._v(" "), _c('p', [_vm._v("Please allow up to 48 hours while we verify it.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Your documentation is being verified.")]), _vm._v(" "), _c('p', [_vm._v("Please allow up to 48 hours while we verify it.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Additional documentation required")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix discover"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "text-muted mr-sm",
    attrs: {
      "href": "#",
      "title": "Download"
    }
  }, [_c('em', {
    staticClass: "fa fa-download fa-fw"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "file-icon ph-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('em', {
    staticClass: "fa fa-5x fa-file-image-o text-green"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "group-span-filestyle input-group-btn",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('label', {
    staticClass: "btn btn-default",
    attrs: {
      "for": "filestyle-0"
    }
  }, [_c('span', {
    staticClass: "icon-span-filestyle fa fa-folder-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "buttonText"
  }, [_vm._v("Choose file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "panel-list mt-lg mb-xl text-muted"
  }, [_c('li', {
    staticClass: "help-block"
  }, [_vm._v("Ensure that your document has not expired.")]), _vm._v(" "), _c('li', {
    staticClass: "help-block"
  }, [_vm._v("The document should not look fuzzy or cropped.")]), _vm._v(" "), _c('li', {
    staticClass: "help-block"
  }, [_vm._v("Make sure the name and address match your investor profile information.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90117f44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentUpload.vue
// module id = 2190
// module chunks = 1